import softDelete from '../../../abstract/actions/soft-delete';
import edit from './edit';

export default {
  edit,
  softDelete,
};
